import m from "../../../../geodata/es2015/region/usa/wvLow";
window.am4geodata_region_usa_wvLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/wvLow.js
// module id = null
// module chunks = 